define.alias("ember-cli-string-helpers/helpers/capitalize", "settings/helpers/capitalize");